<!--
 * @Author       : 周家正
 * @Date         : 2021-07-15 16:43:14
 * @LastEditors  : 周家正
 * @LastEditTime : 2021-09-23 15:43:13
 * @Description  : mask页面
-->
<template>
  <div class="globlMask" v-if="globalMaskShow">
        <van-loading size="54px"  vertical color="#FA6300" >加载中...</van-loading>
  </div>
</template>
<script>
  import store from '@/store/index'
  export default {
    name: 'global-mask',
    components: {
    },
    data() {
      return {
      }
    },
    computed: {
        globalMaskShow: {
            get: function () {
               return store.getters['app/getGlobalMaskShow']
            },
            set: function () {}
        }
    },
    created () { // 实例被创建之后执行代码
           console.log(store.getters['app/getGlobalMaskShow'])
    },
    methods:{
        // toJSON(){
        //     return this
        // }
    }
  }
</script>
<style lang="less" scoped>

  .globlMask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: #ffffff;
    z-index: 99999;
    .van-loading{
        margin-top:50%;
        .van-loading__text{
            color: red;
        }
    }
  }
  </style>